import _ from 'lodash';

export default function simpleSelectorCreator(path, defaultRes) {
  return (state) => _.get(state, path, defaultRes);
}
